import { createModel } from '@rematch/core';
import { compareStrings, trimStart } from '../helpers/functions'
import { client } from '../shared/apiClient';
import axios from "axios";
import i18next from 'i18next';

// @ts-ignore
import { moment } from "cwb-react";

const queryString = require('qs')

const scheduling = createModel({
  state: {
    requestData: {
      audDataM: null,
      audDataD: null,
      audDataY: null,
      selectedProject: null,
      selectedBd: null,
      bdType: 0,
      scheduleName: null,
      oldSelectedProjectId: -1,
      selectedSchedule: null
    },
    availableTS: [],
    selectedTS: [],
    selectedTsInfo: {},
    bdRoles: [],
    roleTypes: [],
    genders: [],
    roleSpots: [],
    newRole: {},
    roleChoices: {},
    submitSchedule: false,
    isLoadingTs: false,
    isLoadingTSInfo: false,
    colChoices: {}
  }, // initial state
  reducers: {
    // handle state changes with pure functions
    appendRequestData: (state: any, payload: any) => ({
      ...state,
      requestData: {
        ...payload
      }
    }),
    setAvailableTS: (state: any, availableTS: any) => ({
      ...state,
      availableTS
    }),
    addSelectedTS: (state: any, selectedTS: any) => ({
      ...state,
      selectedTS: [
        ...state.selectedTS,
        selectedTS
      ]
    }),
    setTSInfo: (state: any, teamShare) => {
      state.selectedTsInfo[teamShare.teamShareId] = {
        teamShareId: teamShare.teamShareId,
        teamShareTitle: teamShare.title || teamShare.teamShareTitle,
        reportColumns: teamShare.reportColumns,
        roles: teamShare.roles.map((role: any) => ({
          sourceRoleId: role.roleId,
          ...role
        }))
      };
      return {
        selectedTsInfo: state.selectedTsInfo,
        ...state
      }
    },
    removeTeamShare: (state: any, teamShareId: any) => {
      const selected = state.selectedTS;
      const index = selected.indexOf(teamShareId);
      index > -1 && selected.splice(index, 1);
      delete state.selectedTsInfo[teamShareId];
      return {
        ...state,
        selectedTS: [...selected],
        selectedTsInfo: state.selectedTsInfo
      }

    },
    setBdRoles: (state: any, bdRoles: any) => ({
      ...state,
      bdRoles
    }),
    setRoleTypes: (state: any, roleTypes: any) => ({
      ...state,
      roleTypes
    }),
    setRoleGenders: (state: any, genders: any) => ({
      ...state,
      genders
    }),
    setRoleSpots: (state: any, roleSpots: any) => ({
      ...state,
      roleSpots
    }),
    setRoleChoices: (state: any, role: any) => {
      let choicesAvailable = role.choices.some((choice: any) => {
        return choice.choiceLevelId > -1;
      });
      state.roleChoices[role.roleId] = choicesAvailable;
      return {
        ...state,
        roleChoices: { ...state.roleChoices }
      }
    },
    setSubmitSchedule: (state: any, submitSchedule: any) => ({
      ...state,
      submitSchedule
    }),
    setLoadingTS: (state: any, isLoadingTS: any) => ({
      ...state,
      isLoadingTS
    }),
    setLoadingTSInfo: (state: any, isLoadingTSInfo: any) => ({
      ...state,
      isLoadingTSInfo
    })
  },
  effects: (dispatch: any) => ({
    // handle state changes with impure functions.
    // use async/await for async actions
    async incrementAsync(payload: any, state: any) {
      await new Promise(resolve => setTimeout(resolve, 1000))
      dispatch.count.increment(payload)
    },

    loadRequestData(): boolean {
      if (window.location.search) {
        const qsArgs = trimStart('?', decodeURI(window.location.search))
        const result = queryString.parse(qsArgs);
        dispatch.scheduling.appendRequestData({
          audDataM: result.AudDateM ? (parseInt(result.AudDateM, 10) - 1) : 0,
          audDataD: result.AudDateD,
          audDataY: result.AudDateY,
          selectedProject: result.userselectedproject ? result.userselectedproject.slice(1) : '',
          selectedBd: result.userselectedbd ? result.userselectedbd.slice(1) : '',
          bdType: result.userselectedbd ? result.userselectedbd.slice(0, 1) : '',
          scheduleName: result.schedulename,
          oldSelectedProjectId: result.olduserselectedprojectid,
          selectedSchedule: result.userselectedsechedule,
          back: result.back
        });
        return true;
      } else {
        return false;
      }
    },

    async loadData({ bdId, isCommercial }) {
      this.setLoadingTS(true);
      await axios.all([
        client.api.schedule.getAvailableTeamShares(),
        client.api.schedule.getBreakdownRoles(bdId, isCommercial),
        client.api.schedule.getRoleTypes(),
        client.api.schedule.getRoleGenders(),
        isCommercial && client.api.schedule.getRoleSpots(bdId, isCommercial)
      ])
        .then(axios.spread(function (tsResp: any, bdRolesResp: any, roleTypesResp: any, gendersResp: any, bdRoleSpots: any) {
          // Set Available TeamShares
          dispatch.scheduling.setAvailableTS(tsResp.data);

          // Set Breakdown roles
          const bdRoles = bdRolesResp.data.length > 0 && bdRolesResp.data.map((role: any) => ({
            label: role.name,
            value: role.id
          }));
          dispatch.scheduling.setBdRoles(bdRoles);

          // Set Role Types
          const roleTypes = roleTypesResp.data.length > 0 && roleTypesResp.data.map((type: any) => ({
            label: type.name,
            value: type.id,
            ...type
          }));
          dispatch.scheduling.setRoleTypes(roleTypes);

          // Set Role Genders
          const roleGenders = gendersResp.data.length > 0 && gendersResp.data.map((gender: any) => ({
            label: gender.name,
            value: gender.id
          }));
          dispatch.scheduling.setRoleGenders(roleGenders);

          // Set Role Spots
          if (isCommercial) {
            let spots = bdRoleSpots.data.map((spot: any) => ({
              label: `Commercial ${spot.displayOrder}`,
              value: spot.id,
              ...spot
            }))
            spots.push({ addNew: true, label: 'New Spot', value: -1 });
            dispatch.scheduling.setRoleSpots(spots);
          }
        })).catch((err) => {
          console.log(err);
          dispatch.alert.showAlert("error", i18next.t("Server error"));
        }).finally(() => {
          this.setLoadingTS(false);
        });
    },

    async getTeamShareInfo(teamShare, state) {
      try {
        this.setLoadingTSInfo(true);
        const tsResp = await client.api.schedule.getTeamShareChoiceInfo(teamShare);
        const rolesInfo = tsResp.data.result && tsResp.data.result.roles.map((role: any) => {
          let obj = { targetRoleId: -1, isNewRole: false };
          let prevMatchPercent = 0;
          state.scheduling.bdRoles.forEach((bdRole: any) => {
            if (bdRole.label) {
              const matchPercent = compareStrings(role.roleName, bdRole.label);
              if (matchPercent > 0.7 && prevMatchPercent < matchPercent) {
                prevMatchPercent = matchPercent;
                obj = { targetRoleId: bdRole.value, isNewRole: false };
              }
            }
          })
          dispatch.scheduling.setRoleChoices(role);
          return {
            ...role,
            targetRoleId: obj.targetRoleId,
            isNewRole: obj.isNewRole,
            options: []
          }
        });
        await dispatch.scheduling.setTSInfo({ ...tsResp.data.result, roles: rolesInfo });
      } catch (err) {
        console.log(err);
        dispatch.alert.showAlert("error", i18next.t("Error while getting response"));
      } finally {
        this.setLoadingTSInfo(false);
      }
    },

    async createSchedule(_, state: any) {
      let teamShares: any = [];
      let showModal = false;
      let isValid = true;
      Object.keys(state.scheduling.selectedTsInfo).forEach(function (key) {
        const value = state.scheduling.selectedTsInfo[key];
        const ts = state.scheduling.availableTS.find((ts: any) => ts.teamShareId === value.teamShareId);
        let tsRoles: any = [];
        value.roles.forEach((role: any, index: number) => {
          if (((role.targetRoleId > 0 || role.isNewRole) && role.options.length === 0)) {
            showModal = true;
          } else if (role.options.length > 0 && (role.targetRoleId === -1 && !role.isNewRole)) {
            showModal = false;
            isValid = false;
            dispatch.alert.showAlert("error", `${i18next.t("Please select breakdown role for")} ${role.roleName}`);
          } else if ((role.targetRoleId > 0 || role.isNewRole) && role.options.length > 0) {
            tsRoles = [...tsRoles, role];
          }
        })

        if (tsRoles.length === 0) {
          isValid = false;
          dispatch.alert.showAlert("error", `${value.teamShareTitle} ${i18next.t("does not have any selection.")}`);
        }

        const teamShare = {
          userId: ts.userId,
          userType: ts.userType,
          ...value,
          roles: tsRoles
        }
        teamShares = [...teamShares, teamShare];
      }, this);
      if (!isValid) return;
      if (showModal) {
        dispatch.modal.openConfirmModal({
          message: i18next.t("There are roles without selections. Are you sure you want to continue? Roles without selections won't be created in the new Scheduling."),
          onConfirm: async () => {
            dispatch.modal.closeModal();
            dispatch.scheduling.submitSchedule(teamShares);
          }
        })
      } else {
        dispatch.scheduling.submitSchedule(teamShares);
      }
    },

    async submitSchedule(teamShares: any, state: any) {
      const scheduleDate = moment.moment([state.scheduling.requestData.audDataY, state.scheduling.requestData.audDataM, state.scheduling.requestData.audDataD])

      const dto = {
        scheduleName: state.scheduling.requestData.scheduleName,
        scheduleDate,
        breakdownId: state.scheduling.requestData.selectedBd,
        isCommercial: state.scheduling.requestData.bdType === "2",
        projectId: state.scheduling.requestData.selectedProject,
        teamShares
      }

      this.setSubmitSchedule(true);
      try {
        const tsResp = await client.api.schedule.submitSchedule(dto);
        if (tsResp.data.result) {
          dispatch.alert.showAlert("success", i18next.t(tsResp.data.message));
          setTimeout(() => {
            window.location.assign(tsResp.data.redirectUrl)
          }, 2000);
        } else {
          dispatch.alert.showAlert("error", i18next.t("Error while Creating Schedule"));
        }
      } catch (err) {
        const errors = err.response.data;
        if (errors) {
          errors['ProjectId'] && dispatch.alert.showAlert("error", errors['ProjectId']);
          errors['BreakdownId'] && dispatch.alert.showAlert("error", errors['BreakdownId']);
          errors.Message && dispatch.alert.showAlert("error", errors.Message);
        } else {
          dispatch.alert.showAlert("error", i18next.t("Error while Creating Schedule"));
        }
      } finally {
        this.setSubmitSchedule(false);
      }
    }
  })
});



export default scheduling;
